export default __webpack_public_path__ + "static/media/nwqxgl.4185b675.png";